"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snapshot = void 0;
const tslib_1 = require("tslib");
const html2canvas_1 = tslib_1.__importDefault(require("html2canvas"));
const constant_1 = require("./constant");
/**
 * 生成快照
 * @param {HTMLElement} el el
 * @returns {Promise<string | undefined>} dataUrl dataUrl
 */
const snapshot = async (el) => {
    try {
        //等待渲染
        const canvas = await (0, html2canvas_1.default)(el, {
            useCORS: true,
            backgroundColor: null,
            logging: false
        });
        //关闭抗锯齿
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error('context is null');
        }
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        const pic = canvas.toDataURL('image/png', 1);
        console.log(pic, 'pic');
        if (pic.length < constant_1.DEFAULT_LENGTH) {
            console.log(pic.length);
            throw new Error(`pic length is less than ${constant_1.DEFAULT_LENGTH}`);
        }
        else {
            return pic;
        }
    }
    catch (e) {
        console.error('snapshot err', e);
        return undefined;
    }
};
exports.snapshot = snapshot;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsc0VBQXNDO0FBQ3RDLHlDQUE0QztBQUU1Qzs7OztHQUlHO0FBQ0ksTUFBTSxRQUFRLEdBQUcsS0FBSyxFQUFFLEVBQWUsRUFBK0IsRUFBRTtJQUMzRSxJQUFJLENBQUM7UUFDRCxNQUFNO1FBQ04sTUFBTSxNQUFNLEdBQUcsTUFBTSxJQUFBLHFCQUFXLEVBQUMsRUFBRSxFQUFFO1lBQ2pDLE9BQU8sRUFBRSxJQUFJO1lBQ2IsZUFBZSxFQUFFLElBQUk7WUFDckIsT0FBTyxFQUFFLEtBQUs7U0FDakIsQ0FBQyxDQUFDO1FBQ0gsT0FBTztRQUNQLDhEQUE4RDtRQUM5RCxNQUFNLE9BQU8sR0FBUSxNQUFNLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQzdDLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQztZQUNYLE1BQU0sSUFBSSxLQUFLLENBQUMsaUJBQWlCLENBQUMsQ0FBQztRQUN2QyxDQUFDO1FBQ0QsT0FBTyxDQUFDLHdCQUF3QixHQUFHLEtBQUssQ0FBQztRQUN6QyxPQUFPLENBQUMsMkJBQTJCLEdBQUcsS0FBSyxDQUFDO1FBQzVDLE9BQU8sQ0FBQyx1QkFBdUIsR0FBRyxLQUFLLENBQUM7UUFDeEMsT0FBTyxDQUFDLHFCQUFxQixHQUFHLEtBQUssQ0FBQztRQUN0QyxNQUFNLEdBQUcsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUMsQ0FBQztRQUM3QyxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQztRQUN4QixJQUFJLEdBQUcsQ0FBQyxNQUFNLEdBQUcseUJBQWMsRUFBRSxDQUFDO1lBQzlCLE9BQU8sQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQ3hCLE1BQU0sSUFBSSxLQUFLLENBQUMsMkJBQTJCLHlCQUFjLEVBQUUsQ0FBQyxDQUFDO1FBQ2pFLENBQUM7YUFBTSxDQUFDO1lBQ0osT0FBTyxHQUFHLENBQUM7UUFDZixDQUFDO0lBQ0wsQ0FBQztJQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7UUFDVCxPQUFPLENBQUMsS0FBSyxDQUFDLGNBQWMsRUFBRSxDQUFDLENBQUMsQ0FBQztRQUNqQyxPQUFPLFNBQVMsQ0FBQztJQUNyQixDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBOUJXLFFBQUEsUUFBUSxZQThCbkIifQ==